let openParticipantEconomyDialogImpl:
  | ((participantUid: string) => void)
  | undefined;

export function registerOpenParticipantEconomyDialog(
  impl: (participantUid: string) => void
): () => void {
  openParticipantEconomyDialogImpl = impl;
  return () => {
    if (openParticipantEconomyDialogImpl === impl) {
      openParticipantEconomyDialogImpl = undefined;
    }
  };
}

export function openParticipantEconomyDialog(participantUid: string): void {
  if (!openParticipantEconomyDialogImpl) {
    console.error("ParticipantEconomyDialogHost is not mounted");
    return;
  }
  openParticipantEconomyDialogImpl(participantUid);
}
